export default __webpack_public_path__ + "static/media/891282db6415a27c71d562b93ebab6021581617516561.3c8ff8fd.webp";